import { put, takeLatest, call } from "redux-saga/effects";
import { EDIT_PROFILE, EDIT_PROFILE_SUCCESS, EDIT_PROFILE_FAIL } from "./actionTypes";

// const apiurl = "https://your-api-url.com"; // Replace with actual API URL

// Function to make API call
const updateUserApi = async ({user}) => {
  console.log(user.username)
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/user/${user._id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${sessionStorage.getItem("authToken")}`
    },
    body: JSON.stringify({
      username: user.username,
      email: user.email,
      phone: user.phone,
    }),
  });

  if (!response.ok) {
    throw new Error("Failed to update profile");
  }
  // const responseData = await response.json();
  // console.log({responseData})

  return await response.json();
};

// Saga to handle editProfile action
function* editProfileSaga(action) {
  try {
    const updatedUser = yield call(updateUserApi, action.payload);
    yield put({ type: EDIT_PROFILE_SUCCESS, payload: updatedUser });
  } catch (error) {
    console.log({error})
    yield put({ type: EDIT_PROFILE_FAIL, payload: error.message });
  }
}

// Watch for EDIT_PROFILE action
export function* watchEditProfile() {
  yield takeLatest(EDIT_PROFILE, editProfileSaga);
}
